import React, { useState, useCallback } from 'react';
import { IEditorProps } from './Editor';
import { DateRangeFilter } from 'components/DateRangeFilter/DateRangeFilter';
import { getChildValue, getPropertyDisplayLabel } from 'components/property-editors/utils/ProviderNodeUtils';
import { ReportDateRange } from '@decisions/server/DecisionsFramework/Design/Flow/CoreSteps/Metro/ReportDateRange';
import { EditorLabel } from './EditorLabel';
import { EditorValidationWrapper } from './EditorValidationWrapper';
import { Label } from 'components/inputs/Label';
import { getISODateStringWithUtcOffset } from 'utils/DateTimeUtils';

interface IReportDateRangeEditorProps extends IEditorProps {}
export function ReportDateRangeEditor({ child, id, path, onChange }: IReportDateRangeEditorProps) {
  const [value, setValue] = useState(getChildValue(child));
  const label = getPropertyDisplayLabel(child);
  const onSelectionChange = useCallback(
    (selectedDateRangeFilter: ReportDateRange) => {
      if (selectedDateRangeFilter?.FromDate?.toJSON) {
        // JSON.stringify converts the date to UTC equivalent hence overriding the toJSON method here
        selectedDateRangeFilter.FromDate.toJSON = function() {
          return getISODateStringWithUtcOffset(this);
        };
      }
      setValue(selectedDateRangeFilter);
      onChange(selectedDateRangeFilter, path);
    },
    [onChange, path]
  );
  return (
    <EditorLabel editor={child} path={path} htmlFor={id} doNotWrap hideInputLabel={true} data-testid={id}>
      <EditorValidationWrapper editor={child}>
        <Label className="dpc-date-range-filter-editor__label" label={label}>
          <DateRangeFilter
            wrapperClass="dpc-date-range-filter-editor__date-filter"
            buttonClass="dpc-date-range-filter-editor__button"
            showInLayer={true}
            dateRangeFilterData={value}
            onSelectionChange={onSelectionChange}
          />
        </Label>
      </EditorValidationWrapper>
    </EditorLabel>
  );
}
